export function getPostLoginPath(from, fallback = "/") {
  if (typeof from !== "string" || !from.startsWith("/") || from.startsWith("//")) {
    return fallback;
  }
  return from;
}

